import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES } from '@ptl/xhr';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProducerStateStructure } from 'src/app/angular-elements/producer/configs/interfaces/producerStateStructure.interface';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME } from '@ptl/account-management';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CheckboxConfig, DocumentOrderRequestPayload } from '../interfaces/doc-order-form.interface';
import { EntryConfigInterface, FormConfig, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';

const MULTICHECKBOX_VALIDATOR_TYPE = 'multi-checkbox-validator';

@Injectable({
    providedIn: 'root'
})
export class DocumentOrderFormBuilderService {

    constructor(
    ) { }
  
    // Uses a shorthand config from the main form config's "customConfigs" section to build checkbox inputs
    buildDocumentCheckboxes(formConfig: DefaultFormConfig) {
      let checkboxConfig = formConfig.form.customConfigs.checkboxEntries || [];
  
      checkboxConfig.forEach((configObj: CheckboxConfig) => {
        let newEntryConfig = this.getBaseFormComponentObj(formConfig);
        newEntryConfig.formControlAttributes.connectPath = formConfig.form.customConfigs.checkboxConnectPath;
        newEntryConfig.formControlAttributes.formControlName = configObj.formControlName;
        newEntryConfig.formControlAttributes.label = configObj.label;
        newEntryConfig.base.formListeners[0].triggers.push({
          "conditional": [
              {
                  "formControlNames": [formConfig.form.customConfigs.checkboxParentKey],
                  "comparator": "===",
                  "comparatorValue": configObj.parentVal
              },
              {
                  "formControlNames": ["year"],
                  "comparator": "===",
                  "comparatorValue": configObj.year
              }
          ],
          "targetProperty": "base.display",
          "onPassChangePropertyValueTo": true,
          "onFailChangePropertyValueTo": false
        });
  
        formConfig.pages[0].entries.push(newEntryConfig);

        this.addEntryToValidator(formConfig, configObj);
      });
    }

    // The necessary validator will have a matching conditional trigger, so we can search all the entries for that
    // specific component and add the new entry's formControlName to the list inside the validation component
    addEntryToValidator(formConfig: DefaultFormConfig, configObj: CheckboxConfig) {
        let validatorEntry = formConfig.pages[0].entries.filter((entry) => {
            let isMultiValidatorComponent = entry.base.componentType === MULTICHECKBOX_VALIDATOR_TYPE;
            let isMatchingTrigger = entry.base.formListeners?.[0]?.triggers?.[0]?.conditional?.[0]?.comparatorValue === configObj.parentVal;
            return isMultiValidatorComponent && isMatchingTrigger;
        });

        validatorEntry?.[0]?.custom?.formControlNames?.push(configObj.formControlName);
    }
  
    getBaseFormComponentObj(formConfig: DefaultFormConfig): EntryConfigInterface {
      return {
        "order": formConfig.form.customConfigs.checkboxOrder,
        "base": {
            "componentType": "checkbox-input",
            "display": false,
            "formListeners": [
                {
                    "triggers": []
                }
            ],
            "formBroadcast": [
                {
                    "type": "valueChange",
                    "signal": "value"
                }
            ]
        },
        "formControlAttributes": {
            "connectPath": formConfig.form.customConfigs.checkboxConnectPath,
            "formControlName": "replace me",
            "label": "replace me"
        },
        "checkboxAttributes": {
            "checkboxLabel": "deprecated",
            "value": true
        }
      };
    }
}
